import { globalFetch, post, deleteRequest } from "foundation/js/api"

export default {
    namespaced: true,
    state: {
        submitting: false,
        aktivitet_list: [],
        rolle_list: [],
        gruppe_list: [],
        member_data: {
            id: "",
            details: [],
            name: "", 
            memberRoles: [],
            imgSrc: "", 
            profileText: "",
            imageAlt: "", 
            answerLink: ""
        },
        has_frivillig_order: false,
    },
    mutations: {
        SET_AKTIVITET_LIST(state, object){
            state.aktivitet_list = object
        },
        SET_ROLLE_LIST(state, object){
            state.rolle_list = object
        },
        SET_GRUPPE_LIST(state, object){
            state.gruppe_list = object
        },
        SET_IS_SUBMITTING(state, object){
            state.submitting = object
        },
        SET_MEMBER_DATA(state,memberData){
            state.member_data = memberData
        },
        SET_HAS_FRIVILLIG_ORDER(state, hasFrivilligOrder){
            state.has_frivillig_order = hasFrivilligOrder
        }
    },
    getters: {

    },
    actions: {
        fetchAktiviteter(context){
            const url = `${document.location.origin}`
                + `/${process.env.FRIVILLIGPROFIL_AKTIVITETER_GET}`
            
            context.commit("SET_IS_SUBMITTING", true)

            return globalFetch(url)
                .then((response) => {
                    if (response.ok) {
                        return response.json()
                    }
                    context.commit("SET_IS_SUBMITTING", false)
                    throw new Error(response.error)
                })
                .then((json) => {
                    context.commit("SET_IS_SUBMITTING", false)
                    context.commit('SET_AKTIVITET_LIST', json)
                })
                .catch((error) => {
                    context.commit("SET_IS_SUBMITTING", false)
                    console.error("Error:", error)
                })
        },
        fetchGrupper(context, activityId){
            const url = `${document.location.origin}`
                + `/${process.env.FRIVILLIGPROFIL_GRUPPER_GET}`.replace('[aktivitetsId]', activityId)
            
            context.commit("SET_IS_SUBMITTING", true)

            return globalFetch(url)
                .then((response) => {
                    if (response.ok) {
                        return response.json()
                    }
                    context.commit("SET_IS_SUBMITTING", false)
                    throw new Error(response.error)
                })
                .then((json) => {
                    context.commit("SET_IS_SUBMITTING", false)
                    context.commit('SET_GRUPPE_LIST', json)
                })
                .catch((error) => {
                    context.commit("SET_IS_SUBMITTING", false)
                    console.error("Error:", error)
                })
        },
        fetchRoller(context, activityId){
            const url = `${document.location.origin}`
                + `/${process.env.FRIVILLIGPROFIL_ROLLER_GET}`.replace('[aktivitetsId]', activityId)
            
            context.commit("SET_IS_SUBMITTING", true)

            return globalFetch(url)
                .then((response) => {
                    if (response.ok) {
                        return response.json()
                    }
                    context.commit("SET_IS_SUBMITTING", false)
                    throw new Error(response.error)
                })
                .then((json) => {
                    context.commit("SET_IS_SUBMITTING", false)
                    context.commit('SET_ROLLE_LIST', json)
                })
                .catch((error) => {
                    context.commit("SET_IS_SUBMITTING", false)
                    console.error("Error:", error)
                })
        },
        async getProfileHasFrivilligOrders(context, config) {
            let url = `${document.location.origin}/${process.env.PROFILE_HAS_FRIVILLIG_ORDERS.replace('[userProfileId]', config)}`
            
            return globalFetch(url)
                .then((response) => {
                    if (response.ok) {
                        return response.json()
                    }
                    throw new Error(response.error)
                })
                .then((json) => {
                    context.commit('SET_HAS_FRIVILLIG_ORDER', json)
                })
                .catch((error) => {
                    console.error("Error:", error)
                })
        },
        async submitRoleRequest(context, config) {
            let url = `${document.location.origin}`
                + `/${process.env.SUBMIT_ROLE_ASSIGNMENT}`

            const method = process.env.POSTMETHOD

            const headers = new Headers()
            headers.append("Content-Type", "application/json")
            const body = JSON.stringify(config.body)
            const init = {
                headers,
                method,
                body: JSON.stringify(config.body),
            }
            context.commit("SET_IS_SUBMITTING", true)

            if (method !== "POST") delete init.body // leave this in

            return globalFetch(url, init)
                .then((response) => {
                    context.commit("SET_IS_SUBMITTING", false)
                    if (response.ok) {
                        location.reload()
                        return response;
                    }
                    
                    throw new Error(response.error)
                })
                .catch((error) => {
                    context.commit("SET_IS_SUBMITTING", false)
                    console.error("Error:", error)
                })
        },
        async rejectGruppeadgangsanmodning(context, id) {
            let url = `${document.location.origin}`
                + `/${process.env.DELETE_ROLE_REQUEST}`.replace('[id]', id)

            const method = process.env.DELETEMETHOD

            const headers = new Headers()
            headers.append("Content-Type", "application/json")

            const init = {
                headers,
                method,
            }
            context.commit("SET_IS_SUBMITTING", true)

            if (method !== "DELETE") delete init.body // leave this in

            return globalFetch(url, init)
                .then((response) => {
                    context.commit("SET_IS_SUBMITTING", false)
                    if (response.ok) {
                        location.reload()
                        return response;
                    }
                    
                    throw new Error(response.error)
                })
                .catch((error) => {
                    context.commit("SET_IS_SUBMITTING", false)
                    console.error("Error:", error)
                })
        },
        async deleteRolletildeling(context, id) {
            let url = `${document.location.origin}`
                + `/${process.env.DELETE_ROLE_ASSIGNMENT}`.replace('[id]', id)

            const method = process.env.DELETEMETHOD

            const headers = new Headers()
            headers.append("Content-Type", "application/json")

            const init = {
                headers,
                method,
            }
            context.commit("SET_IS_SUBMITTING", true)

            if (method !== "DELETE") delete init.body // leave this in

            return globalFetch(url, init)
                .then((response) => {
                    context.commit("SET_IS_SUBMITTING", false)
                    if (response.ok) {
                        location.reload()
                        return response;
                    }
                    
                    throw new Error(response.error)
                })
                .catch((error) => {
                    context.commit("SET_IS_SUBMITTING", false)
                    console.error("Error:", error)
                })
        },
        async createProfil(context, config) {
            let url = `${document.location.origin}`
                + `/${process.env.CREATE_FRIVILLIG_PROFILE}`.replace('[pageId]', config.pageId)

            const method = process.env.POSTMETHOD

            const headers = new Headers()
            headers.append("Content-Type", "application/json")

            const init = {
                headers,
                method,
                body: JSON.stringify(config.body)
            }
            context.commit("SET_IS_SUBMITTING", true)

            if (method !== "POST") delete init.body // leave this in

            return globalFetch(url, init)
                .then((response) => {
                    if (response.ok) {
                        return response.json();
                    }
                    
                    throw new Error(response.error)
                })
                .then(json => {
                    window.location.href = json.continueUrl
                    return json
                })
                .catch((error) => {
                    context.commit("SET_IS_SUBMITTING", false)
                    console.error("Error:", error)
                })
        },
        async submitFrivilligProfilePicture(context, config) {
            const url = `${document.location.origin}/${process.env.SUBMIT_FRIVILLIG_PROFILE_PICTURE}`
            const body = config.formData
            return await post(url, body, null, true)
        },
        async removeFrivilligProfilePicture(context) {
            const url = `${document.location.origin}/${process.env.SUBMIT_FRIVILLIG_PROFILE_PICTURE}`
            return await deleteRequest(url, null, null, true)
        },
        async editFrivilligprofil(context, config) {
            let url = `${document.location.origin}`
                + `/${process.env.EDIT_FRIVILLIG_PROFILE}`.replace('[pageId]', config.pageId)

            const method = process.env.PATCHMETHOD

            const headers = new Headers()
            headers.append("Content-Type", "application/json")

            const init = {
                headers,
                method,
                body: JSON.stringify(config.body)
            }
            context.commit("SET_IS_SUBMITTING", true)

            if (method !== "PATCH") delete init.body // leave this in

            return globalFetch(url, init)
                .then((response) => {
                    context.commit("SET_IS_SUBMITTING", false)
                    if (response.ok) {
                        return response;
                    }
                    
                    throw new Error(response.error)
                })
                .catch((error) => {
                    context.commit("SET_IS_SUBMITTING", false)
                    console.error("Error:", error)
                    location.reload()
                })
        },
        fetchMemberData(context, config){
            const url = `${document.location.origin}`
                + `/${process.env.GET_FRIVILLIGPROFIL_CARD_DATA
                    .replace("[id]", config.userProfileId)
                    .replace("[pageId]", config.pageId)}`

            context.commit("SET_IS_SUBMITTING", true)

            return globalFetch(url)
                .then((response) => {
                    if (response.ok) {
                        return response.json()
                    }
                    context.commit("SET_IS_SUBMITTING", false)
                    throw new Error(response.error)
                })
                .then((json) => {
                    context.commit('SET_MEMBER_DATA', json)

                    context.commit("SET_IS_SUBMITTING", false)
                })
                .catch((error) => {
                    context.commit("SET_IS_SUBMITTING", false)
                    console.error("Error:", error)
                })
        },
        async deleteFrivilligprofil(context, config) {
            let url = `${document.location.origin}/${process.env.DELETE_FRIVILLIGPROFIL
                .replace("[guid]", config.id)
                .replace("[pageId]", config.pageId)}`
        
            const method = process.env.DELETEMETHOD

            const headers = new Headers()
            headers.append("Content-Type", "application/json")

            const init = {
                headers,
                method,
            }
            context.commit("SET_IS_SUBMITTING", true)

            if (method !== "DELETE") delete init.body // leave this in

            return globalFetch(url, init)
                .then((response) => {
                    context.commit("SET_IS_SUBMITTING", false)
                    if (response.ok) {
                        window.location.href = config.continueUrl
                        return response;
                    }
                    
                    throw new Error(response.error)
                })
                .catch((error) => {
                    context.commit("SET_IS_SUBMITTING", false)
                    console.error("Error:", error)
                })
        },
    }

}
